import { ArrowRightAltRounded } from '@mui/icons-material'
import { ButtonBase, Card, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ExpensesIcon, IncomeIcon, PackageIcon, ProfitIcon } from '../../../../../atoms/icons'
import HeaderSkeleton from '../../../../common/skeletons/HeaderSkeleton'

export default function ContentHeader() {

    const {push} = useHistory()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(()=>{

        setIsLoading(true)
        const timeOut = setTimeout(()=>{
            setIsLoading(false)
        },3000)

        return ()=>clearTimeout(timeOut)
        
    },[])

    const handleRevenueOnClick = ()=>{
        push("/sales")
    }

    const handleProfitOnClick = ()=>{
        push("/sales")
    }

    const handleMoneyLeftOnClick = ()=>{
        push("/sales")
    }

    const handleItemsInShopOnClick = ()=>{
        push("/sales")
    }
    
    return (
        <>
            {
                !isLoading ? (
                    <Stack direction="row" spacing={2} >

                        <Card variant="outlined" sx={styles.cardMin}>

                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ProfitIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Gross Revenue</Typography>
                                        <Typography variant="h6" > GH₵ 12.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >See more on sales</Typography>

                                    <ButtonBase onClick={handleRevenueOnClick} focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                            
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ExpensesIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Gross Profit</Typography>
                                        <Typography variant="h6" >GH₵ 1.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                <Typography color={grey[500]} fontSize="14px" fontWeight="light" >See more on sales</Typography>

                                <ButtonBase onClick={handleProfitOnClick} focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                    <ArrowRightAltRounded htmlColor={grey[500]} />
                                </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <IncomeIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Actual Cash In Shop</Typography>
                                        <Typography variant="h6" > GH₵ 1.2K</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >View all expenses</Typography>

                                    <ButtonBase onClick={handleMoneyLeftOnClick} focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}}  justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <PackageIcon />
                                    </div>

                                    <Typography textAlign="left" >
                                        <Typography color={grey[500]}>Items In Current Stock</Typography>
                                        <Typography variant="h6" > 1,200</Typography>
                                    </Typography>

                                </Stack>

                                <Stack direction="row"  alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >See inventory</Typography>

                                    <ButtonBase onClick={handleItemsInShopOnClick} focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                    
                    </Stack>
                ):(
                    <HeaderSkeleton/>
                )
            }
        </>
    )
}


const styles={

    cardMin: {
        flex: 1, 
        height: 150, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    }
    
}